var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 893 314",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-74.2282,-227.023)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,309.495,433.483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-33.934C0,-20.949 -10.527,-10.422 -23.512,-10.422C-36.497,-10.422 -47.024,-20.949 -47.024,-33.934L-57.464,-34.017C-57.464,-15.185 -42.197,0.083 -23.364,0.083C-4.559,0.083 10.688,-15.14 10.734,-33.934L0,-33.934Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,177.346,227.257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,33.934C0,20.949 10.527,10.422 23.512,10.422C36.497,10.422 47.024,20.949 47.024,33.934L57.464,34.017C57.464,15.185 42.197,-0.083 23.364,-0.083C4.559,-0.083 -10.689,15.14 -10.734,33.934L0,33.934Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,378.167,529.334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-41.725C0,-25.858 -12.815,-12.988 -28.659,-12.891L-28.659,0L-28.658,0C-5.592,0 13.11,-18.671 13.166,-41.725L0,-41.725Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,111.461,529.334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-41.725C0,-25.858 12.815,-12.988 28.659,-12.891L28.659,0L28.658,0C5.592,0 -13.11,-18.671 -13.166,-41.725L0,-41.725Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,474.154,399.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18.423C-0.582,18.423 -1.165,18.343 -1.615,18.265L-1.88,16.57C-1.324,16.73 -0.689,16.835 0.026,16.835C1.826,16.835 2.885,15.856 2.885,13.791L2.885,0L4.711,0L4.711,13.819C4.711,16.967 2.779,18.423 0,18.423",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,524.674,416.991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.256L-0.291,10.402C-1.667,11.619 -3.098,12.521 -4.791,12.521C-7.305,12.521 -8.523,11.065 -8.523,8.682L-8.523,-0.265L-6.776,-0.265L-6.776,8.364C-6.776,9.98 -6.035,10.932 -4.447,10.932C-3.123,10.932 -1.773,10.138 -0.397,8.788L-0.397,-0.265L1.35,-0.265L1.35,12.256L0,12.256Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,562.694,416.247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.519L-0.291,10.852C-1.454,11.937 -2.91,12.784 -4.711,12.784C-6.882,12.784 -8.442,11.592 -8.442,9.369C-8.442,6.431 -6.061,5.054 -0.396,4.498L-0.396,3.678C-0.396,1.985 -1.402,1.27 -2.989,1.27C-4.473,1.27 -5.929,1.718 -7.305,2.38L-7.543,0.82C-6.088,0.184 -4.658,-0.265 -2.885,-0.265C-0.105,-0.265 1.324,1.031 1.324,3.599L1.324,12.519L0,12.519ZM-0.396,5.874C-5.319,6.378 -6.695,7.569 -6.695,9.263C-6.695,10.614 -5.77,11.301 -4.445,11.301C-3.097,11.301 -1.613,10.56 -0.396,9.421L-0.396,5.874Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,601.688,415.498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.784L0,4.155C0,2.541 -0.741,1.561 -2.33,1.561C-3.653,1.561 -5.003,2.382 -6.379,3.73L-6.379,12.784L-8.126,12.784L-8.126,0.263L-6.776,0.263L-6.485,2.117C-5.109,0.898 -3.679,0 -1.985,0C0.503,0 1.747,1.428 1.747,3.837L1.747,12.784L0,12.784Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,671.821,401.121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,17.656L-1.854,18.053L-7.782,9.794L-10.138,9.794L-10.138,17.867L-11.965,17.867L-11.965,-0.397L-7.306,-0.397C-3.732,-0.397 -1.456,1.404 -1.456,4.58C-1.456,7.412 -3.282,9.027 -5.797,9.556L0,17.656ZM-7.386,1.219L-10.138,1.219L-10.138,8.232L-7.702,8.232C-5.003,8.232 -3.31,7.015 -3.31,4.685C-3.31,2.463 -4.738,1.219 -7.386,1.219",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,701.978,416.247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.519L-0.291,10.852C-1.455,11.937 -2.911,12.784 -4.711,12.784C-6.882,12.784 -8.443,11.592 -8.443,9.369C-8.443,6.431 -6.062,5.054 -0.397,4.498L-0.397,3.678C-0.397,1.985 -1.403,1.27 -2.99,1.27C-4.473,1.27 -5.929,1.718 -7.305,2.38L-7.543,0.82C-6.088,0.184 -4.659,-0.265 -2.885,-0.265C-0.106,-0.265 1.324,1.031 1.324,3.599L1.324,12.519L0,12.519ZM-0.397,5.874C-5.32,6.378 -6.696,7.569 -6.696,9.263C-6.696,10.614 -5.771,11.301 -4.446,11.301C-3.097,11.301 -1.614,10.56 -0.397,9.421L-0.397,5.874Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,728.322,415.499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.021C-1.667,13.021 -3.415,12.493 -4.5,11.883L-4.208,10.189C-3.044,10.93 -1.509,11.54 0.159,11.54C1.905,11.54 2.99,10.798 2.99,9.528C2.99,8.284 2.25,7.728 -0.239,7.065C-3.018,6.351 -4.208,5.452 -4.208,3.387C-4.208,1.427 -2.541,0 0.052,0C1.535,0 2.832,0.342 3.944,0.846L3.653,2.513C2.514,1.905 1.244,1.535 0,1.535C-1.721,1.535 -2.541,2.274 -2.541,3.307C-2.541,4.34 -1.853,4.87 0.265,5.425C3.229,6.218 4.659,7.172 4.659,9.395C4.659,11.671 2.885,13.021 0,13.021",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,761.854,415.499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.021C-1.668,13.021 -3.415,12.493 -4.5,11.883L-4.209,10.189C-3.044,10.93 -1.509,11.54 0.159,11.54C1.905,11.54 2.991,10.798 2.991,9.528C2.991,8.284 2.25,7.728 -0.239,7.065C-3.019,6.351 -4.209,5.452 -4.209,3.387C-4.209,1.427 -2.541,0 0.052,0C1.535,0 2.832,0.342 3.944,0.846L3.653,2.513C2.514,1.905 1.244,1.535 0,1.535C-1.721,1.535 -2.541,2.274 -2.541,3.307C-2.541,4.34 -1.854,4.87 0.265,5.425C3.229,6.218 4.659,7.172 4.659,9.395C4.659,11.671 2.885,13.021 0,13.021",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,830.486,415.498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.784L0,4.155C0,2.541 -0.661,1.561 -2.276,1.561C-3.573,1.561 -4.87,2.354 -6.246,3.705L-6.246,12.784L-7.967,12.784L-7.967,4.155C-7.967,2.541 -8.628,1.561 -10.243,1.561C-11.54,1.561 -12.863,2.354 -14.214,3.678L-14.214,12.784L-15.96,12.784L-15.96,0.263L-14.61,0.263L-14.319,2.063C-12.97,0.873 -11.567,0 -9.899,0C-7.967,0 -6.908,0.794 -6.458,2.17C-5.082,0.926 -3.626,0 -1.905,0C0.583,0 1.747,1.428 1.747,3.81L1.747,12.784L0,12.784Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,871.497,416.991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.256L-0.291,10.402C-1.667,11.619 -3.097,12.521 -4.791,12.521C-7.305,12.521 -8.522,11.065 -8.522,8.682L-8.522,-0.265L-6.775,-0.265L-6.775,8.364C-6.775,9.98 -6.034,10.932 -4.446,10.932C-3.122,10.932 -1.772,10.138 -0.396,8.788L-0.396,-0.265L1.351,-0.265L1.351,12.256L0,12.256Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,898.219,415.499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.021C-1.667,13.021 -3.415,12.493 -4.5,11.883L-4.208,10.189C-3.044,10.93 -1.509,11.54 0.159,11.54C1.905,11.54 2.99,10.798 2.99,9.528C2.99,8.284 2.25,7.728 -0.239,7.065C-3.019,6.351 -4.208,5.452 -4.208,3.387C-4.208,1.427 -2.541,0 0.052,0C1.535,0 2.832,0.342 3.944,0.846L3.653,2.513C2.514,1.905 1.244,1.535 0,1.535C-1.721,1.535 -2.541,2.274 -2.541,3.307C-2.541,4.34 -1.854,4.87 0.265,5.425C3.229,6.218 4.659,7.172 4.659,9.395C4.659,11.671 2.885,13.021 0,13.021",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,931.748,415.499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.021C-1.667,13.021 -3.415,12.493 -4.5,11.883L-4.208,10.189C-3.044,10.93 -1.509,11.54 0.159,11.54C1.905,11.54 2.99,10.798 2.99,9.528C2.99,8.284 2.25,7.728 -0.239,7.065C-3.018,6.351 -4.208,5.452 -4.208,3.387C-4.208,1.427 -2.541,0 0.052,0C1.535,0 2.832,0.342 3.944,0.846L3.653,2.513C2.514,1.905 1.244,1.535 0,1.535C-1.721,1.535 -2.541,2.274 -2.541,3.307C-2.541,4.34 -1.854,4.87 0.265,5.425C3.229,6.218 4.659,7.172 4.659,9.395C4.659,11.671 2.885,13.021 0,13.021",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,473.702,475.626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,18.264L0,0L9.529,0L9.529,1.643L1.826,1.643L1.826,7.888L7.914,7.888L8.179,9.53L1.826,9.53L1.826,16.623L9.793,16.623L9.793,18.264L0,18.264Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,524.522,491.122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.049C-3.203,13.049 -5.664,10.667 -5.664,6.537C-5.664,2.329 -3.123,0 0.054,0C1.747,0 3.098,0.529 4.129,1.272L3.838,3.018C2.647,2.011 1.456,1.509 0.027,1.509C-2.354,1.509 -3.891,3.442 -3.891,6.511C-3.891,9.61 -2.354,11.514 0.187,11.514C1.509,11.514 2.7,11.145 3.997,10.031L4.235,11.62C3.018,12.572 1.667,13.049 0,13.049",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,569.581,473.531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,19.005L0,10.376C0,8.763 -0.741,7.782 -2.33,7.782C-3.653,7.782 -5.003,8.604 -6.379,9.952L-6.379,19.005L-8.126,19.005L-8.126,0.318L-6.379,0L-6.379,8.259C-5.082,7.12 -3.679,6.222 -1.985,6.222C0.503,6.222 1.747,7.65 1.747,10.032L1.747,19.005L0,19.005Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,614.191,509.237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.238L-8.708,0.238C-8.656,3.308 -7.227,5.134 -4.713,5.134C-3.045,5.134 -1.589,4.394 -0.291,3.282L-0.027,4.871C-1.271,5.928 -2.886,6.644 -4.818,6.644C-8.101,6.644 -10.455,4.421 -10.455,0.106C-10.455,-3.917 -8.127,-6.406 -5.056,-6.406C-1.642,-6.406 0,-3.599 0,-0.132L0,0.238ZM-5.056,-5.002C-7.015,-5.002 -8.285,-3.547 -8.63,-1.138L-1.801,-1.138C-1.985,-3.388 -3.045,-5.002 -5.056,-5.002",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,638.438,491.122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.049C-3.203,13.049 -5.665,10.667 -5.665,6.537C-5.665,2.329 -3.124,0 0.052,0C1.745,0 3.097,0.529 4.129,1.272L3.838,3.018C2.646,2.011 1.455,1.509 0.026,1.509C-2.356,1.509 -3.892,3.442 -3.892,6.511C-3.892,9.61 -2.356,11.514 0.186,11.514C1.508,11.514 2.699,11.145 3.996,10.031L4.234,11.62C3.018,12.572 1.666,13.049 0,13.049",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,673.538,491.122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.049C-3.203,13.049 -5.611,10.667 -5.611,6.537C-5.611,2.382 -3.149,0 0,0C3.256,0 5.69,2.382 5.69,6.537C5.69,10.667 3.203,13.049 0,13.049M0,1.483C-2.488,1.483 -3.838,3.573 -3.838,6.537C-3.838,9.423 -2.461,11.568 0,11.568C2.541,11.568 3.891,9.502 3.891,6.537C3.891,3.653 2.514,1.483 0,1.483",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,714.179,504.378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8.256C-1.244,8.256 -2.355,8.018 -3.257,7.648L-3.257,12.651L-5.003,12.942L-5.003,-4.423L-3.653,-4.423L-3.361,-2.623C-2.383,-3.734 -1.139,-4.686 0.687,-4.686C3.414,-4.686 5.718,-2.702 5.718,1.481C5.718,6.059 3.044,8.256 0,8.256M0.503,-3.126C-0.979,-3.126 -2.117,-2.253 -3.257,-0.876L-3.257,6.033C-2.276,6.509 -1.35,6.774 -0.053,6.774C2.196,6.774 3.943,5.054 3.943,1.559C3.943,-1.485 2.488,-3.126 0.503,-3.126",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,762.45,491.878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.517L-0.291,10.85C-1.454,11.935 -2.911,12.783 -4.711,12.783C-6.882,12.783 -8.443,11.591 -8.443,9.368C-8.443,6.429 -6.061,5.053 -0.396,4.497L-0.396,3.677C-0.396,1.984 -1.402,1.269 -2.989,1.269C-4.473,1.269 -5.929,1.718 -7.305,2.379L-7.543,0.819C-6.087,0.182 -4.658,-0.266 -2.885,-0.266C-0.105,-0.266 1.324,1.03 1.324,3.597L1.324,12.517L0,12.517ZM-0.396,5.873C-5.319,6.376 -6.695,7.568 -6.695,9.261C-6.695,10.612 -5.77,11.3 -4.445,11.3C-3.097,11.3 -1.613,10.558 -0.396,9.42L-0.396,5.873Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,783.406,513.353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-2.937L0,4.923L-1.746,4.923L-1.746,-7.596L-0.45,-7.596L-0.052,-5.028C0.874,-6.432 2.33,-7.808 4.395,-7.86L4.686,-6.219C2.621,-6.087 0.848,-4.605 0,-2.937",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,481.531,346.393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-8.848L0,-5.482L3.732,-5.482L4.097,-3.251L0,-3.251L0,2.212L-2.539,2.212L-2.539,-11.06L4.885,-11.06L4.885,-8.848L0,-8.848Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,537.162,315.116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.502C-3.213,13.502 -5.31,11.598 -5.31,8.136L-5.31,0L-2.771,0L-2.771,8.001C-2.771,10.021 -1.847,11.29 0.019,11.29C1.903,11.29 2.846,10.098 2.846,8.059L2.846,0L5.404,0L5.404,8.078C5.404,11.598 3.211,13.502 0,13.502",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,605.787,315.118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.271L-6.252,4.135L-6.252,13.271L-8.617,13.271L-8.617,0L-6.213,0L-0.25,8.693L-0.25,0L2.115,0L2.115,13.271L0,13.271Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,653.088,315.118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.271L-4.212,13.271L-4.212,0L0,0C4.617,0 7.002,2.712 7.002,6.616C7.002,10.559 4.521,13.271 0,13.271M-0.019,2.096L-1.673,2.096L-1.673,11.174L-0.057,11.174C2.731,11.174 4.405,9.751 4.405,6.635C4.405,3.577 2.635,2.096 -0.019,2.096",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,724.328,314.953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.464L-1.269,9.963L-6.29,9.963L-7.501,13.329L-10.021,13.329L-5.039,0L-2.327,0L2.539,13.002L0,13.464ZM-3.789,2.77L-5.597,7.886L-1.98,7.886L-3.789,2.77Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,772.939,314.463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.733C-3.866,13.733 -6.29,11.002 -6.29,6.886C-6.29,2.769 -3.771,0 -0.02,0C1.519,0 2.712,0.365 3.692,0.962L3.327,3.366C2.462,2.712 1.384,2.193 0.096,2.193C-2.251,2.193 -3.693,3.981 -3.693,6.867C-3.693,9.79 -2.155,11.521 0.191,11.521C1.423,11.521 2.538,11.079 3.558,10.405L3.903,12.598C2.847,13.272 1.5,13.733 0,13.733",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,-679.161,-558.451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.422,
    y: 308.907,
    width: 2.559,
    height: 13.271,
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,865.324,303.475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,17.638C-3.771,17.638 -6.213,14.868 -6.213,10.772C-6.213,6.655 -3.75,3.866 0.039,3.866C3.847,3.866 6.252,6.636 6.252,10.733C6.252,14.83 3.808,17.638 0,17.638M0.019,5.982C-2.25,5.982 -3.616,7.848 -3.616,10.752C-3.616,13.657 -2.25,15.522 0.019,15.522C2.309,15.522 3.674,13.657 3.674,10.752C3.674,7.848 2.289,5.982 0.019,5.982M0.442,2.904L-1.077,2.904L0.347,0L3.135,0.52L0.442,2.904Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,935.311,315.118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,13.271L-6.252,4.135L-6.252,13.271L-8.617,13.271L-8.617,0L-6.213,0L-0.25,8.693L-0.25,0L2.115,0L2.115,13.271L0,13.271Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.82794,0,0,2.82794,470.38,374.807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L169.52,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "white",
      strokeWidth: "1.22px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.35a65a4532dc5fe82079b51804844611.svg";
export { ForwardRef as ReactComponent };